import React, {ReactNode} from 'react';
import Logout from './Logout';
import Page, {PageType} from '@episerver/spa-core/Page';
import LogoutPageData from '../../../Models/Content/LogoutPageData';

export default class LogoutPage extends Page<LogoutPageData> {
  public render(): ReactNode | null {
    return (
      <div>
        <Logout context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}
